import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=a1216eda&scoped=true"
import script from "./my-pagination.vue?vue&type=script&lang=ts"
export * from "./my-pagination.vue?vue&type=script&lang=ts"
import style0 from "./my-pagination.vue?vue&type=style&index=0&id=a1216eda&prod&scoped=true&lang=scss"
import style1 from "./my-pagination.vue?vue&type=style&index=1&id=a1216eda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1216eda",
  null
  
)

export default component.exports